import React from "react";
import { Box } from "rebass";
import { MdAddCircle, MdCheckCircle } from "react-icons/md";

interface IProps {
  checked: boolean;
}

export const FileActionIcon: React.FC<IProps> = ({ checked }) => (
  <Box color={checked ? "forest-green" : "sp-blue"} css="transition: .4s all;">
    {
      checked
        ? <MdCheckCircle display="block" size={26} />
        : <MdAddCircle display="block" size={26} />
    }
  </Box>
);
